import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import back from "../../svg/back.svg";
import cancel from "../../svg/cancel-green.svg";
import search from "../../svg/search_dark.svg";
import more from "../../svg/more.svg";
import androidBack from "../../svg/back-android.svg";

class HelpAndSupportHeader extends Component {
  /**
   * it changes the header size on scroll
   */
  handleHeaderScroll = () => {
    let shrinkOn = 90;
    let distanceY = window.pageYOffset || document.documentElement.scrollTop;
    if (distanceY > shrinkOn && this.props.displayMessage.title !== "") {
      if (document.getElementById("header").style.height > "40px") {
        document.getElementById("header").style.display = "flex";
        document.getElementById("header").style.height = "40px";
        document.getElementById("headerTitle").style.fontSize = "16px";
        document.getElementById("headerDesc").style.fontSize = "10px";
        document.getElementById("headerTitle").style.width = "calc(100% - 65px)";
        document.getElementsByClassName("body-container")[0].style.marginTop = "45px";
      }
    } else if (this.props.displayMessage.title !== "" && document.getElementById("header").style.height < "80px") {
      if (this.props.displayMessage.description === "") {
        document.getElementsByClassName("body-container")[0].style.marginTop = "85px";
      } else {
        document.getElementsByClassName("body-container")[0].style.marginTop = "100px";
      }
      document.getElementById("header").style.display = "block";
      document.getElementById("header").style.height = "80px";
      document.getElementById("headerTitle").style.width = "100%";
      document.getElementById("headerTitle").style.fontSize = "22px";
      document.getElementById("headerDesc").style.fontSize = "12px";
    }
  };

  componentDidMount() {
    if (this.props.displayMessage.title === "") {
      document.getElementsByClassName("body-container")[0].style.marginTop = "55px";
      document.getElementById("header").style.height = "50px";
      document.getElementById("headerTitle").style.fontSize = "18px";
      document.getElementById("headerDesc").style.fontSize = "11px";
    } else {
      this.scrollListner = window.addEventListener("scroll", this.handleHeaderScroll);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.displayMessage.title === "") {
      document.getElementsByClassName("body-container")[0].style.marginTop = "55px";
      document.getElementById("header").style.height = "50px";
      document.getElementById("headerTitle").style.fontSize = "18px";
      document.getElementById("headerDesc").style.fontSize = "11px";
    } else {
      if (document.getElementById("header").style.height < "80px") {
        if (nextProps.displayMessage.description === "") {
          document.getElementsByClassName("body-container")[0].style.marginTop = "85px";
        } else {
          document.getElementsByClassName("body-container")[0].style.marginTop = "100px";
        }
        document.getElementById("header").style.display = "block";
        document.getElementById("header").style.height = "80px";
        document.getElementById("headerTitle").style.fontSize = "22px";
        document.getElementById("headerDesc").style.fontSize = "12px";
      }
      this.scrollListner = window.addEventListener("scroll", this.handleHeaderScroll);
    }
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleHeaderScroll);
  }
  render() {
    const { deviceType } = this.props;
    const backBtn = deviceType == 0 ? androidBack : back;
    return (
      <div className="faq-header" id="header">
        <div className="faq-header-icon">
          <img
            className="faq-header-icon-img"
            src={this.props.displayMessage.backIcon ? backBtn : cancel}
            onClick={this.props.back.bind(this)}
            alt=""
          />
          {this.props.displayMessage.moreOptionhidden ? (
            ""
          ) : (
            <img className="faq-header-icon-img-right" src={more} onClick={this.props.moreOption.bind(this)} alt="" />
          )}
          {this.props.displayMessage.searchOptionHidden ? (
            ""
          ) : (
            <Link to="/search" className="faq-header-icon-img-right">
              <img className="" src={search} alt="" />
            </Link>
          )}
        </div>
        <div className="faq-header-message">
          <div className="faq-header-message-title" id="headerTitle">
            {this.props.displayMessage.title}
          </div>
          <div className="faq-header-message-description" id="headerDesc">
            {this.props.displayMessage.description}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ deviceType }) => ({ deviceType });

export default connect(mapStateToProps)(HelpAndSupportHeader);



// WEBPACK FOOTER //
// ./src/components/CommonComponents/HelpAndSupportHeader.js